import { __rest } from "tslib";
import * as React from 'react';
const PlayFillLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", fill: "currentColor", width: size || "32", height: size || "32" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "m26.416 14.94-15.5-9.748A1.25 1.25 0 0 0 9 6.25v19.497a1.25 1.25 0 0 0 1.916 1.057l15.5-9.748c.366-.23.584-.626.584-1.058a1.24 1.24 0 0 0-.584-1.058Z" })));
};
PlayFillLarge.displayName = 'PlayFillLarge';
export default PlayFillLarge;
//# sourceMappingURL=PlayFillLarge.js.map